import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useNotes = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["notes", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.NOTES.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useNotesFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["notesFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.NOTES.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useNotesOptions = (params = {}) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["notesOptions", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.NOTES.getOptions}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCreateNotes = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.NOTES.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.NOTES.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateNotes = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.NOTES.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.NOTES.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteNotes = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.NOTES.base}/${id}`,
                token,
                toastError: true,
                toastMessage:true
            })
            return data
        },
    })
}